import React, { useState, useRef, useEffect, useContext } from 'react';
import {
  Wrapper,
  Placeholder,
  IconWrapper,
  Ubigeo,
  ContentModal,
  IconClose,
  LoaderWrapper
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import { PredictiveResultsModal } from './PredictiveResultsModal';
import { Modal } from '@app/src/common/Modal';
import { PredictiveInput } from './PredictiveInput';
import { DataListModel } from './DataListModel';
import { PredictiveContext } from './PredictiveConstructor';

const MIN_CHARACTERES = 3;

export const PredictiveInputModal: React.FC = () => {

  const {
    dataList,
    handleChange,
    handleClickClose,
    defaultUbigeo,
    error,
    disabled,
    isLoading
  } = useContext(PredictiveContext);
  const [value, setValue] = useState('');
  const [currentValue, setCurrentValue] = useState('');
  const [suggestionsList, setSuggestionsList] = useState([]);
  const [activeSuggestion, setActiveSuggestion] = useState(-1);
  const [formatValue, setFormatValue] = useState([]);
  const refWrapper = useRef(null);
  const refClose = useRef(null);
  const [displayModal, setDisplayModal] = useState(false);
  let refInput = null;

  useEffect(() => {
    if (value) {
      let formatValue = value.split(',');
      setFormatValue(formatValue)
    }
  }, [value])

  useEffect(() => {
    if (defaultUbigeo) {
      setValue(defaultUbigeo);
      setCurrentValue(defaultUbigeo);
    } else {
      setValue('');
      setCurrentValue('');
    }
  }, [defaultUbigeo]);

  useEffect(() => {
    if(suggestionsList[activeSuggestion]) {
      setValue(suggestionsList[activeSuggestion].data.location);
      setCurrentValue(suggestionsList[activeSuggestion].data.location);
      refInput.current.style.display = 'none';
    }
  }, [activeSuggestion]);

  useEffect(() => {
    if (displayModal) {
      if (value) {
        refInput.current.style.display = 'none';
      }
    }
  }, [displayModal, value]);

  const handleClickInput = () => {
    refInput.current.style.display = 'block';
    setCurrentValue('');
    refInput.current.focus();
  }

  const handleChangeRadioInput = (_value:string, index: number) => {
    setActiveSuggestion(index);
    handleChange && handleChange(suggestionsList[index]);
    setTimeout(() => {
      setDisplayModal(false);
    }, 200)
  }

  const handleClickCloseModal = () => {
    setDisplayModal(false);
  }

  const handleClickWrapper = () => {
    setDisplayModal(true);
  }

  const getResults = (results: DataListModel[]) => {
    setSuggestionsList(results.length > 0 ? results : dataList);
  }

  const handleChangeInput = (value: string) => {
    setCurrentValue(value);
  }

  const handleClickClear = () => {
    refInput.current.style.display = 'block';
    clearInput();
    refInput.current.focus();
  }

  const handleClickCloseOutModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    clearInput();
    handleClickClose && handleClickClose();
  }

  const clearInput = () => {
    setValue('');
    setCurrentValue('');
    setActiveSuggestion(-1);
  }

  return (
  <React.Fragment>
    <Wrapper
      ref={refWrapper}
      onClick={e => (!disabled && !isLoading) && handleClickWrapper(e)}
      borderColor={`1px solid ${error ? 'red' : COLORS.GRAY}`}>
      <IconWrapper>
        <Icon data-name="icon-map" width="18" height="18" fill={COLORS.GRAY_PLACEHOLDER} />
      </IconWrapper>
      {
        value ?
          <React.Fragment>
            <Ubigeo>
            <span>{formatValue[0]}</span>{formatValue[1] ? `, ${formatValue[1]}` : ''} {formatValue[2] ? `, ${formatValue[2]}` : ''}
            </Ubigeo>
            {!disabled && <IconClose onClick={handleClickCloseOutModal}>
              <Icon data-name="icon-close-bold" width="18" height="18" fill={COLORS.GRAY} />
            </IconClose>}
          </React.Fragment>
          :
          <Placeholder>
            <span>Ej. Miraflores</span>, Lima, Lima
          </Placeholder>
      }
      {
        isLoading &&
        <LoaderWrapper>
            <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
        </LoaderWrapper>
      }
      </Wrapper>
      <Modal show={displayModal} closeModal={handleClickCloseModal} customBody>
        <ContentModal>
          <Wrapper>
            <IconWrapper>
              <Icon data-name="icon-map" width="18" height="18" fill={COLORS.GRAY_PLACEHOLDER} />
            </IconWrapper>
            <PredictiveInput
              id="ubigeo"
              value={currentValue}
              minCharacter={MIN_CHARACTERES}
              handleRef={ref => { refInput = ref}}
              getResults={getResults}
              handleClick={handleClickInput}
              handleChange={handleChangeInput}
            />
            {
              (currentValue === '') &&
                <Placeholder>
                  <span>Ej. Miraflores</span>, Lima, Lima
                </Placeholder>
            }
            {
              (currentValue && currentValue === value) &&
                <Ubigeo>
                  <span>{formatValue[0]}</span>{formatValue[1] ? `, ${formatValue[1]}` : ''} {formatValue[2] ? `, ${formatValue[2]}` : ''}
                </Ubigeo>
            }
            {
              (currentValue !== '' || value !== '') &&
                <IconClose onClick={handleClickClear} ref={refClose}>
                  <Icon data-name="icon-close-bold" width="18" height="18" fill={COLORS.GRAY} />
                </IconClose>
            }
          </Wrapper>
          <PredictiveResultsModal
            activeItem={activeSuggestion}
            dataList={suggestionsList}
            showFirstItems={8}
            handleChange={handleChangeRadioInput}
          />
        </ContentModal>
      </Modal>
  </React.Fragment>
)};
